import type { Aircraft } from '../types';

export type MaintenancePerformerType =
  | 'technician'
  | 'organization'
  | 'self'
  | 'other'
  | '';

export const ISSUE_PERFORMER_OPTIONS: {
  value: Exclude<MaintenancePerformerType, ''>;
  label: string;
}[] = [
  { value: 'technician', label: 'Техник' },
  { value: 'organization', label: 'Организация' },
  { value: 'self', label: 'Своими силами' },
  { value: 'other', label: 'Иное' },
];

export function performerFromLabel(
  label?: string | null
): { type: MaintenancePerformerType; name: string } {
  const text = (label || '').trim();
  if (!text) return { type: '', name: '' };
  if (text === 'Техник' || text.startsWith('Техник:')) {
    return { type: 'technician', name: text.replace(/^Техник:\s*/, '').replace(/^Техник$/, '') };
  }
  if (text === 'Организация' || text.startsWith('Организация:')) {
    return {
      type: 'organization',
      name: text.replace(/^Организация:\s*/, '').replace(/^Организация$/, ''),
    };
  }
  if (text === 'Своими силами' || text.startsWith('Своими силами:')) {
    return {
      type: 'self',
      name: text.replace(/^Своими силами:\s*/, '').replace(/^Своими силами$/, ''),
    };
  }
  if (text === 'Иное' || text.startsWith('Иное:')) {
    return {
      type: 'other',
      name: text.replace(/^Иное:\s*/, '').replace(/^Иное$/, ''),
    };
  }
  return { type: '', name: text };
}

export function performerFromAircraft(
  aircraft?: Pick<Aircraft, 'maintenance_type' | 'maintenance_name'> | null
): { type: MaintenancePerformerType; name: string } {
  const mtype = (aircraft?.maintenance_type || '').trim();
  const mname = (aircraft?.maintenance_name || '').trim();
  if (mtype === 'technician' || mtype === 'organization' || mtype === 'self') {
    return { type: mtype, name: mname };
  }
  return { type: '', name: '' };
}

export function issuePerformerFromSaved(
  label?: string | null,
  aircraft?: Pick<Aircraft, 'maintenance_type' | 'maintenance_name'> | null
): { type: MaintenancePerformerType; name: string } {
  const parsed = performerFromLabel(label);
  if (parsed.type) return parsed;
  if (parsed.name) return { type: 'other', name: parsed.name };
  return performerFromAircraft(aircraft);
}

export function formatPerformerLabel(
  type: MaintenancePerformerType | string,
  name?: string | null
): string {
  const n = (name || '').trim();
  if (type === 'technician') return n ? `Техник: ${n}` : 'Техник';
  if (type === 'organization') return n ? `Организация: ${n}` : 'Организация';
  if (type === 'self') return n ? `Своими силами: ${n}` : 'Своими силами';
  if (type === 'other') return n ? `Иное: ${n}` : 'Иное';
  return n;
}

export function formatIssuePerformerLabel(
  type: MaintenancePerformerType | string,
  name?: string | null
): string {
  if (type === 'self') return 'Своими силами';
  return formatPerformerLabel(type, name);
}

export function performerNeedsName(type: MaintenancePerformerType) {
  return type === 'technician' || type === 'organization' || type === 'other';
}

export function performerNamePlaceholder(type: MaintenancePerformerType) {
  if (type === 'organization') return 'Наименование организации';
  if (type === 'other') return 'Своя версия';
  return 'ФИО';
}

export function issuePerformerError(
  type: MaintenancePerformerType,
  name?: string | null
): string | null {
  if (!type) return 'Укажите, кем устранена неисправность';
  if (performerNeedsName(type) && !(name || '').trim()) {
    if (type === 'organization') return 'Укажите наименование организации';
    if (type === 'other') return 'Укажите свою версию';
    return 'Укажите ФИО техника';
  }
  return null;
}
